module.exports = __webpack_public_path__ + "packs/media/images/Rahel-9538843786ad37aca3a54953d3eaf0e0.jpg";